<!-- App Page-unauthorized component -->
<script>
export default {
  name: "app-page-unauthorized"
};
</script>

<!-- Template -->
<template>
  <h2 class="page-not-found">Unauthorized</h2>
</template>

<!-- Style -->
<style lang="scss">
.page-not-found {
  text-align: center;
  margin-top: 124px;
  font-weight: 500;
  color: #888888;
}
</style>
